import React from 'react'
import { Card } from 'primereact/card'
import { Badge } from 'primereact/badge'
import { ShippingOrder } from '../../../../DeShippingTableWrapper'
import { OrderFulfillmentLocationTemplate } from '../../../shared/OrderFulfillmentLocationTemplate'
import { dateTemplate } from '../../../shared/DateTemplate'

interface RejectedOrderCardProps {
  order: ShippingOrder
  onOrderClick?: (order: ShippingOrder) => void
}

export const RejectedOrderCard: React.FC<RejectedOrderCardProps> = ({
  order,
  onOrderClick
}) => {
  const handleCardClick = () => {
    if (onOrderClick) {
      onOrderClick(order)
    }
  }

  // Calculate rejection statistics for this order
  const storeDeclinedItems = order.declined_items || 0
  const adminRejectedItems = 0 // TODO: Add this field to order data if available
  const totalRejectedItems = storeDeclinedItems + adminRejectedItems

  const cardFooter = (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '1rem', flexWrap: 'wrap', fontSize: '0.875rem' }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem', minWidth: '150px' }}>
        <div style={{ color: '#6c757d' }}>Created</div>
        <div>
          {order.created_at ? dateTemplate(order) : 'N/A'}
        </div>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem', minWidth: '150px', textAlign: 'right' }}>
        <div style={{ color: '#6c757d' }}>Location</div>
        <div>
          <OrderFulfillmentLocationTemplate {...order} />
        </div>
      </div>
    </div>
  )

  return (
    <Card 
      title={`Order ${order.order_name}`}
      footer={cardFooter}
      className={`mb-3 ${onOrderClick ? 'cursor-pointer hover:shadow-3' : ''} transition-all transition-duration-200`}
      onClick={onOrderClick ? handleCardClick : undefined}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '1rem', flexWrap: 'wrap' }}>
        {/* Left side - Order Summary */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', minWidth: '200px' }}>
          <div style={{ fontSize: '1.25rem', fontWeight: 'bold' }}>${order.order_subtotal?.toFixed(2) || '0.00'}</div>
          <div style={{ fontSize: '0.875rem', color: '#6c757d' }}>
            {order.total_items} {order.total_items === 1 ? 'item' : 'items'}
          </div>
        </div>

        {/* Right side - Rejection Statistics */}
        <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', alignItems: 'flex-start' }}>
          {storeDeclinedItems > 0 && (
            <Badge 
              value={`${storeDeclinedItems} Store Declined`} 
              severity="warning" 
              className="text-xs"
            />
          )}
          {adminRejectedItems > 0 && (
            <Badge 
              value={`${adminRejectedItems} Admin Rejected`} 
              severity="danger" 
              className="text-xs"
            />
          )}
          <Badge 
            value={`${totalRejectedItems} Total Rejected`} 
            severity="info" 
            className="text-xs"
          />
        </div>
      </div>
    </Card>
  )
} 